import type { ZudokuConfig } from "zudoku";
import { createApiIdentityPlugin } from "zudoku/plugins";

const config: ZudokuConfig = {
  enableStatusPages: false,
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "Cyberprotect",
      width: "230px",
    },
  },
  metadata: {
    title: "%s - Cyberprotect API",
    description: "Cyberprotect Cloud Public API",
    favicon: "./public/favicon.png",
  },
  search: {
    type: "pagefind"
  },
  navigation: [
    {
      type: "category",
      label: "Введение",
      items: [
        {
          type: "category",
          label: "Введение",
          icon: "sparkles",
          items: [
            "/introduction",
            {
              type: "doc",
              icon: "history",
              file: "changelog",
              label: "История изменений",
            },
            {
              type: "link",
              icon: "arrow-big-right",
              label: "справочники API",
              to: "/iam",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/iam",
      label: "IAM",
    },
    {
      type: "link",
      to: "/resources",
      label: "Ресурсы",
    },
    {
      type: "link",
      to: "/policies",
      label: "Политики",
    },
    {
      type: "link",
      to: "/tasks",
      label: "Задачи",
    },
    {
      type: "link",
      to: "/credentials",
      label: "Реквизиты для входа",
    },
    {
      type: "link",
      to: "/archives",
      label: "Резервные копии",
    },
  ],
  plugins: [
    createApiIdentityPlugin({
      getIdentities: async (context) => [
        {
          id: "api-key-one",
          label: "My API Key",
          authorizeRequest: (request) => {
            // We get the access token from the
            // authentication provider (Auth0) and add it to the request headers
            return context.authentication?.signRequest(request) ?? request;
          },
        }
      ]
    }
    )
  ],
  redirects: [{ from: "/", to: "/introduction" }],
  apis: [
    {
      type: "file",
      input: "./apis/openapi_iam.json",
      path: "/iam",
      options:
      {
        disablePlayground: true,
        schemaDownload: {
        enabled: true,
        fileName: "openapi_iam"
        }
      },
    },
    {
      type: "file",
      input: "./apis/openapi_pm.json",
      path: "/policies",
      options:
      {
        disablePlayground: true,
        schemaDownload: {
        enabled: true,
        fileName: "openapi_pm"
        }
      },
    },
    {
      type: "file",
      input: "./apis/openapi_cs.json",
      path: "/credentials",
      options:
      {
        disablePlayground: true,
        schemaDownload: {
        enabled: true,
        fileName: "openapi_cs"
        }
      },
    },
    {
      type: "file",
      input: "./apis/openapi_rm.json",
      path: "/resources",
      options:
      {
        disablePlayground: true,
        schemaDownload: {
        enabled: true,
        fileName: "openapi_rm"
        }
      }
    },
    {
      type: "file",
      input: "./apis/openapi_tm.json",
      path: "/tasks",
      options:
      {
        disablePlayground: true,
        schemaDownload: {
        enabled: true,
        fileName: "openapi_tm"
        }
      },
    },
    {
      type: "file",
      input: "./apis/openapi_vm.json",
      path: "/archives",
      options:
      {
        disablePlayground: true,
        schemaDownload: {
        enabled: true,
        fileName: "openapi_vm"
        }
      },
    },
  ],
};

export default config;